import React, { useEffect } from "react"

import Raw from "@atoms/Raw/Raw"
import UtmHandler from "@atoms/UtmHandler/UtmHandler"

import styles from "./FormScript.module.scss"

const FormScript = ({ anchor, heading, raw }) => {
  UtmHandler()
  useEffect(() => {
    if (
      typeof localStorage !== "undefined" &&
      typeof window !== "undefined" &&
      typeof document !== "undefined"
    ) {
      const formId = "formframe"

      const utmObject = {
        utm_id: localStorage.getItem("almatalent_utm_id"),
        utm_source: localStorage.getItem("almatalent_utm_source"),
        utm_medium: localStorage.getItem("almatalent_utm_medium"),
        utm_campaign: localStorage.getItem("almatalent_utm_campaign"),
        utm_term: localStorage.getItem("almatalent_utm_term"),
        utm_content: localStorage.getItem("almatalent_utm_content"),
      }

      let dataSent = false

      function handleSelligentIframe(event) {
        if (
          !dataSent &&
          typeof event.data === "string" &&
          event.data.includes("sell-iframe")
        ) {
          dataSent = true

          const host = "https://almamedia.slgnt.eu"
          const element = document.getElementById(formId)

          element?.contentWindow.postMessage(utmObject, host)
        }
      }

      window.addEventListener("message", handleSelligentIframe)
      return () => {
        window.removeEventListener("message", handleSelligentIframe)
      }
    }
  }, [])

  return (
    <>
      <section
        id={anchor}
        className={`${styles.element} section-break-out section-break-out-no-margins-mobile large-area-element attached-to-siblings`}
      >
        <div className="container">
          <div className="max-vvw">
            {heading && <h2 className={styles.heading}>{heading}</h2>}
            <div className={styles.raw}>
              <Raw html={raw} />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default FormScript
